import React from "react";

const StatusIcon = ({ index, keyName, userStatus, firstIncompleteIndex }) => {
  console.log("Us ", userStatus);
  const status = userStatus?.[keyName];
  console.log("Keyname status " + keyName + " " + status);

  const getIcon = () => {
    switch (status) {
      case "Completed":
        return <span className="text-green-600">✅</span>;
      case "In Review":
        return <span className="text-yellow-600">🕒</span>;
      case "Reupload":
        return <span className="text-red-600">🔁</span>;
      case "Upload":
      default:
        return index === firstIncompleteIndex ? (
          <span className="text-blue-600" aria-label="Upload required">
            ⬆️
          </span>
        ) : (
          <span className="text-gray-500">❌</span>
        );
    }
  };

  return getIcon();
};

export default StatusIcon;
